import { useEffect } from 'react';

const STYLE_ID_PREFIX = 'rules-engine-scroll-style-';

export default function useGreenScrollbar(testID) {
  useEffect(() => {
    if (!testID || typeof document === 'undefined') return;
    const styleId = `${STYLE_ID_PREFIX}${testID}`;
    if (document.getElementById(styleId)) return;
    const el = document.createElement('style');
    el.id = styleId;
    el.textContent = `
      /* Firefox + standards-compliant browsers (set on the scroll element) */
      [data-testid="${testID}"] {
        scrollbar-color: rgba(28, 187, 119, 0.45) transparent;
        scrollbar-width: thin;
      }
      /* WebKit / Chromium / Blink (set on pseudo-elements) */
      [data-testid="${testID}"]::-webkit-scrollbar {
        width: 5px;
      }
      [data-testid="${testID}"]::-webkit-scrollbar-track {
        background: transparent;
      }
      [data-testid="${testID}"]::-webkit-scrollbar-thumb {
        background: rgba(28, 187, 119, 0.45);
        border-radius: 10px;
      }
      [data-testid="${testID}"]::-webkit-scrollbar-thumb:hover {
        background: rgba(28, 187, 119, 0.75);
      }
    `;
    document.head.appendChild(el);
  }, [testID]);
}
